import React, { FC, useEffect, useState } from 'react';
import { RightOutline } from 'antd-mobile-icons';
import moment from 'moment';
import { getBbsList } from "@/services/api";
import { MTools } from '@/components';
import { SubForum, Title } from '../index';
import styles from './index.less';

interface ComProps {
  style?: React.CSSProperties;
}

const Forum: FC<ComProps> = ({
  style,
}) => {
  const [mainForumData, setMainForumData] = useState<any>([]);
  const [forumList, setForumList] = useState([]);

  useEffect(() => {
    handleGetBbsList('1');
    handleGetBbsList('2');
  }, []);

  const handleGetBbsList = async (type: string) => {
    const result: any = await getBbsList(type);
    if (result.success) {
      if (type == "1") {
        const _data = result.data?.length > 0 ? result.data[0] : {};
        setMainForumData(_data);
      } else {
        const _list = result.data || [];
        const _useList = _list.length > 5 ? _list.slice(0, 5) : _list;
        setForumList(_useList);
      }
    } else {
      MTools.Tips(
        'error',
        '系统异常，请刷新再试'
      );
    }
  };

  const handleGotoDetail = () => {
    MTools.Url.gotoUrl(`/app/ForumDetail/${mainForumData.id}`);
  }

  const goToForumList = () => {
    MTools.Url.gotoUrl(`/app/ForumList`);
  }

  return (
    <div className={styles.comWrapper} style={style}>
      <Title type={1} />
      {/* 主论坛 */}
      <div className={styles.mainForumTip}>
        <div className={styles.forumTipL}>开幕式暨主论坛</div>
        <div className={styles.forumTipR}>{moment(mainForumData.startTime).format('YYYY年M月D日 HH:mm')}</div>
      </div>
      <div className={styles.mainForum} onClick={handleGotoDetail}>
        <img src={mainForumData.cover} alt="" />
      </div>
      {/* 分论坛 */}
      <div className={styles.mainForumTip}>
        <div className={styles.forumTipL}>分论坛</div>
        <div
          className={styles.forumTipR}
          onClick={goToForumList}
        >
          查看更多<RightOutline />
        </div>
      </div>
      <div className={styles.subForum}>
        <SubForum list={forumList} />
      </div>
    </div>
  );
};

export default Forum;
